import { SearchResultListItem } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/SearchResultListItem";
import { DeviceRow } from "@/components/layout/Navbar/ApplicationSearch/application-search.types";
import { useGenerateDevicePath } from "@/routes/routes.utils";

type Props = {
    data: DeviceRow;
    onClick: () => void;
    className?: string;
};

export const DeviceListItem = (props: Props) => {
    const { data } = props;
    const generateDevicePath = useGenerateDevicePath();

    return (
        <SearchResultListItem
            chip={data.DeviceType ?? "Unknown device"}
            label={data.DeviceSerialNumber}
            title={"Device"}
            // @ts-expect-error FIXME: link can be undefined
            url={generateDevicePath({
                customerNumber: data.CustomerNumber,
                deviceSerialNumber: data.DeviceSerialNumber,
                deviceType: data.DeviceType,
                devicePageType: data.DeviceCategory,
            })}
            icon={data.DeviceCategory === "Astronaut" ? "lely-icon-astronaut" : "lely-icon-robot"}
            onClick={props.onClick}
            className={props.className}
        />
    );
};
